import { store } from "@/store.js";

import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

let stompClient = null;

// function handleErrors(response) {
//     const res = JSON.parse(response.body);
//     console.log(JSON.parse(response.body))
//     stompClient.disconnect();
// }
// function handleErrors(response) {
//     console.log(response)
//     stompClient.disconnect();
// }

function closeEventCallback() {
    stompClient.disconnect();
  }

    // Відключаємось від сокету коллбек
    function errorCallback() {
        // setDefaultData()
        // app.messageWarning(lang['ExpirenzaConnectionClose'])
      }

export const connectTypaySocket = (handleTPayMessage,handleSocketError) => {
    const socket = new SockJS('https://ws.tpay.skyservice.online/tPay');
    // const socket = new SockJS('http://46.219.50.186:8181/tPay');
    stompClient = Stomp.over(socket);
    const headers = {
        qrToken: store.tpayId,
    }
    const messageSend={
        "qrToken": `${store.tpayId}`,
        "action":'getOrders'

    }
    
    try {
        stompClient.connect(headers, function () {

            stompClient.subscribe('/user/queue/errors', (err) => {
                // Перевірка на офлайн пост
               
                if(err.body == '1001'){                    
                    handleSocketError(true, err.body)
                    // handleSocketError(true, 1002)
                }else{
                    stompClient.disconnect();
                    // handleErrors(err)
                }
                
            });
            stompClient.subscribe('/user/queue/receiveSkyMessage', (...arg) => {
                handleSocketError(false)
                handleTPayMessage(...arg)
            })
            stompClient.ws.onclose = closeEventCallback;

            sendSocketTypayGuest(messageSend)

        }, errorCallback)
    } catch (error) {
        console.log(error)
    }
    
}

export const sendSocketTypayGuest = (data) => {    
    const companyId = store.companyId;
    window.socketType = data.action; //! current type socket
    // const qrToken=store.tpayId
    stompClient.send("user/queue/terminal/" + companyId, JSON.stringify(data));
    // stompClient.send("user/queue/terminal/faf1c383-b7e9-47aa-9f8b-384ce22bd0ca" , JSON.stringify(data));
}


